import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    close: {
        id: 'iaso.label.close',
        defaultMessage: 'Close',
    },
    markerClustering: {
        id: 'iaso.map.title.markerClustering',
        defaultMessage: 'Clustering',
    },
    layersTitle: {
        id: 'iaso.tile.title',
        defaultMessage: 'Map layers',
    },
    osm: {
        id: 'iaso.tile.osm',
        defaultMessage: 'Open Street Map',
    },
    'arcgis-street': {
        id: 'iaso.tile.arcgis.street',
        defaultMessage: 'ArcGIS Street Map',
    },
    'arcgis-satellite': {
        id: 'iaso.tile.arcgis.satellite',
        defaultMessage: 'ArcGIS Satellite Map',
    },
    'arcgis-topo': {
        id: 'iaso.tile.arcgis.topo',
        defaultMessage: 'ArcGIS Topo Map',
    },
    title: {
        id: 'iaso.map.title.markerClustering',
        defaultMessage: 'Clustering',
    },
    parent: {
        id: 'iaso.label.parent',
        defaultMessage: 'Parent',
    },
    locationNotInShape: {
        id: 'iaso.map.locationNotInShape',
        defaultMessage:
            "The location is not within the bounds of the parent's shape.",
    },
});

export default MESSAGES;
